import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import 'react-select/dist/react-select.css';
import DetailsForGenerate from './DetailsForGenerateBlock/DetailsForGenerate';
import { setDayTabSelect } from '../../actions/setParams';
import { getUsers, selectUser } from '../../actions/users';
import { haveMenu } from '../../actions/rewriteRequest';
import { getDishes } from '../../actions/dishes';
import { deleteDish } from '../../actions/dishDelete';
import { showEditRecepiePopup } from '../../actions/dishEdit';
import { getCalculateCBGU } from '../../actions/calculateCbgu';
import { getPDF } from '../../actions/menuActions';
import MenuBlock from '../Common/MenuBlock';
import { getTags } from '../../actions/tags/getTags';
import {
  getMenuGeneratorTemplates,
  changeMenuGeneratorDishPortion,
  changeMenuGeneratorDish,
  addMenuGeneratorDish,
  deleteMenuGeneratorDish,
  changeMenuGeneratorMealTime,
  changeMenuGeneratorDishTime,
  toggleChangeTheSameDays,
  setMenuMenuGenerator,
} from '../../actions/menu';
import { setQueryParameter } from '../../utils/url-params';
import {
  SMALLER_DAY_VIOLATION,
  BIGGEST_DAY_VIOLATION,
  NONE_DAY_VIOLATION,
  PERCENTAGE_MAX_CALORIES,
  DEFAULT_ACTIVITY_COEFFICIENT,
} from '../../constants/appConstants';

const MenuPage = ({
  users,
  user,
  location,
  // menu properties
  tabSelected = 0,
  setDayTabSelect,
  selectedDayCount,
  menu,
  changeMenuGeneratorDishPortion,
  changeMenuGeneratorDish,
  addMenuGeneratorDish,
  deleteMenuGeneratorDish,
  changeMenuGeneratorMealTime,
  changeMenuGeneratorDishTime,
  cbgu,
  cbgucalories,
  isChangeTheSameDays,
  toggleChangeTheSameDays,
  category,
  sameDaysCount,
  setMenuMenuGenerator,
  dishes,
  tags,
  selectedComplex,
  getUsers,
  getDishes,
  getTags,
}) => {
  const [daysViolations, setDaysViolations] = useState([]);
  const maxCalories = cbgucalories || 0;
  const maxCarbohydrates = cbgu ? cbgu.carbohydrates : 0;
  const maxFats = cbgu ? cbgu.fats : 0;
  const maxProteins = cbgu ? cbgu.proteins : 0;
  let activityCoefficient = DEFAULT_ACTIVITY_COEFFICIENT;
  if (user && user.params && user.params.activity && user.params.activity.coefficient) {
    activityCoefficient = user.params.activity.coefficient;
  }
  useEffect(() => {
    !users.length && getUsers();
    !dishes.length && getDishes();
    !tags.length && getTags();
    if (user && user.id) setQueryParameter('user', user.id);
    if (selectedComplex && selectedComplex.id) setQueryParameter('complex', selectedComplex.id);
  }, []);

  const countTotalFitValuesByDay = React.useCallback((data, valueName) => {
    let totalFitValue = 0;
    data.forEach((eating) => {
      eating.meals.forEach((dishData) => {
        totalFitValue += dishData[`counted_${valueName}`];
      });
    });
    return totalFitValue.toFixed(2);
  });

  const calculatePercentageOfDifferenceInValues = (currentValue, maxValue) => {
    const percentage = ((currentValue - maxValue) * 100) / maxValue;
    return Math.abs(Math.round(percentage));
  };

  const getDayWithExcessCalories = React.useCallback(
    (menu) => {
      const dayViolations = [];
      menu.map((mealsDataForDay) => {
        const totalCalories = countTotalFitValuesByDay(mealsDataForDay, 'calories');
        if (!maxCalories || !maxCarbohydrates || !maxFats || !maxProteins || +totalCalories === 0) {
          dayViolations.push({ violations: NONE_DAY_VIOLATION });
        } else if (totalCalories < maxCalories / activityCoefficient) {
          dayViolations.push({ violations: SMALLER_DAY_VIOLATION });
          return dayViolations;
        } else if (
          totalCalories > maxCalories * 0.9 && // norm calories - 10%
          calculatePercentageOfDifferenceInValues(totalCalories, maxCalories * 0.9) >=
            PERCENTAGE_MAX_CALORIES
        ) {
          dayViolations.push({ violations: BIGGEST_DAY_VIOLATION });
          return dayViolations;
        } else {
          dayViolations.push({ violations: NONE_DAY_VIOLATION });
        }
        return dayViolations;
      });
      setDaysViolations(dayViolations);
    },
    [menu, maxCalories, maxCarbohydrates, maxFats, maxProteins],
  );

  useEffect(() => {
    getDayWithExcessCalories(menu);
  }, [menu, maxCalories, maxCarbohydrates, maxFats, maxProteins]);

  return (
    <React.Fragment>
      <DetailsForGenerate users={users} userIndex={user.id} location={location.pathname} />
      <MenuBlock
        daysCount={selectedDayCount}
        setActiveDayTab={setDayTabSelect}
        activeDayTab={tabSelected}
        menu={menu}
        changeDishPortion={changeMenuGeneratorDishPortion}
        changeDish={changeMenuGeneratorDish}
        addDish={addMenuGeneratorDish}
        deleteDish={deleteMenuGeneratorDish}
        changeMealTime={changeMenuGeneratorMealTime}
        changeDishTime={changeMenuGeneratorDishTime}
        isChangeTheSameDays={isChangeTheSameDays}
        toggleChangeTheSameDays={toggleChangeTheSameDays}
        category={category}
        sameDaysCount={sameDaysCount}
        setMenuMenuGenerator={setMenuMenuGenerator}
        countTotalFitValuesByDay={countTotalFitValuesByDay}
        daysViolations={daysViolations}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { users, userUpdated, dishes, user } = state.reducers;
  const {
    selectedDayCount,
    menu,
    menuAllTemplates,
    isChangeTheSameDays,
    sameDaysCount,
  } = state.menu;
  const { calloriesNorm, tabSelected } = state.setParams;
  const { username, password } = state.login;
  const { tags } = state.getTags;
  const { cbgu, cbgucalories } = state.calculateCbgu;
  const { selectedComplex } = state.complex;
  const { category } = state.setParams;
  return {
    username,
    password,
    users,
    userUpdated,
    calloriesNorm,
    selectedDayCount,
    // menus block
    user,
    tabSelected,
    dishes,
    tags,
    menu,
    cbgu,
    cbgucalories,
    menuAllTemplates,
    selectedComplex,
    isChangeTheSameDays,
    category,
    sameDaysCount,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPDF: (id) => {
      dispatch(getPDF(id));
    },
    haveMenu: (id, dates, method) => {
      dispatch(haveMenu(id, dates, method));
    },
    getUsers: () => {
      dispatch(getUsers());
    },
    selectUser: (userId) => {
      dispatch(selectUser(userId));
    },
    getDishes: () => {
      dispatch(getDishes());
    },
    getCalculateCBGU: (userData) => {
      dispatch(getCalculateCBGU(userData));
    },
    showEditRecepiePopup: (data) => {
      dispatch(showEditRecepiePopup(data));
    },
    deleteDish: (data) => {
      dispatch(deleteDish(data));
    },
    setDayTabSelect: (data) => {
      dispatch(setDayTabSelect(data));
    },
    getTags: () => {
      dispatch(getTags());
    },
    getMenuGeneratorTemplates: () => {
      dispatch(getMenuGeneratorTemplates());
    },
    //  new menu block
    changeMenuGeneratorDishPortion: (dishId, value) => {
      dispatch(changeMenuGeneratorDishPortion(dishId, value));
    },
    changeMenuGeneratorDish: (positionDishId, newDishId) => {
      dispatch(changeMenuGeneratorDish(positionDishId, newDishId));
    },
    addMenuGeneratorDish: (dayNumber, mealType) => {
      dispatch(addMenuGeneratorDish(dayNumber, mealType));
    },
    deleteMenuGeneratorDish: (positionDishId) => {
      dispatch(deleteMenuGeneratorDish(positionDishId));
    },
    changeMenuGeneratorMealTime: (dayIndex, type, timeValue) => {
      dispatch(changeMenuGeneratorMealTime(dayIndex, type, timeValue));
    },
    changeMenuGeneratorDishTime: (positionDishId, timeValue) => {
      dispatch(changeMenuGeneratorDishTime(positionDishId, timeValue));
    },
    toggleChangeTheSameDays: () => {
      dispatch(toggleChangeTheSameDays());
    },
    setMenuMenuGenerator: (menu) => {
      dispatch(setMenuMenuGenerator(menu));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuPage);



// WEBPACK FOOTER //
// ./src/Components/MenuGenerator/MenuPage.jsx